// Array of regEx or string used to validate each character of a string. Masks can also be used
// to format the string (e.g. add a () around phone regional indicator)
type TextInputMaskValue = (RegExp | string)[];
export type TextInputMask = TextInputMaskValue | ((value: string) => TextInputMaskValue);

export interface InputMaskConfig {
  // Mask represent format using regex
  mask: TextInputMask;
  // Post operations is used to change input before it's displayed
  // mainly used for text transformation such as upper and lower case
  maskPostOperation?: (value: string) => string;
}

// Create base mask from input max length and accepted characters
export const createBaseMask = (regex: RegExp, maxLength: number): TextInputMask => {
  // Mask includes the same regex for all input character
  const mask: RegExp[] = [];
  for (let i = 0; i < maxLength; i++) {
    mask.push(regex);
  }

  return mask;
};
